import './ReportFormSectionConfig.scss';
import { FieldPath } from '@form-ts/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button } from 'src/modules/common/components/Button';
import { HorizontalDivider } from 'src/modules/common/components/HorizontalDivider';
import { ArrowRightIcon } from 'src/modules/common/icons/ArrowRightIcon';
import { Project } from 'src/modules/common/types/Project';
import { BodyMedium01 } from 'src/modules/common/typography/BodyMedium01';
import { CheckboxField } from 'src/modules/form/components/CheckboxField';
import { FormError } from 'src/modules/form/types/FormError';
import { ReportFormData } from 'src/modules/report/types/ReportFormData';
import { ReportFormFieldToggle } from 'src/modules/report/views/ReportFormFieldToggle';

type Props = {
  readonly field: FieldPath<ReportFormData, FormError, ReportFormData['energy']>;
  readonly project: Project;
};

export const ReportFormSectionConfigEnergy = ({ field, project }: Props): React.ReactElement => (
  <div className="bp-report-form-section-config">
    <div className="bp-report-form-section-config__header">
      <BodyMedium01>
        <FormattedMessage id="report/form/energy/header"/>
      </BodyMedium01>

      <CheckboxField field={field.at('enabled')}/>
    </div>

    <HorizontalDivider/>

    <div className="bp-report-form-section-config__content">
      <ReportFormFieldToggle
        field={field.at('showHeating')}
        disabled={!project.data.hvac.areas.heating.enabled}
      >
        <FormattedMessage id="report/form/energy/showHeating"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle
        field={field.at('showCooling')}
        disabled={!project.data.hvac.areas.cooling.enabled}
      >
        <FormattedMessage id="report/form/energy/showCooling"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle
        field={field.at('showVentilation')}
        disabled={!project.data.hvac.areas.ventilation.enabled}
      >
        <FormattedMessage id="report/form/energy/showVentilation"/>
      </ReportFormFieldToggle>

      <ReportFormFieldToggle
        field={field.at('showComments')}
      >
        <FormattedMessage id="report/form/energy/showComments"/>
      </ReportFormFieldToggle>
    </div>

    <div className="bp-report-form-section-config__action">
      <Button
        fullWidth={true}
        as={Link}
        to={`/project/${encodeURIComponent(project.id)}/hvac`}
        kind="tertiary"
        size="md"
      >
        <FormattedMessage id="report/form/energy/editLinkText"/>

        <div className="bp-report-form-section-config__button-icon">
          <ArrowRightIcon/>
        </div>
      </Button>
    </div>
  </div>
);
